import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackByNoComponent } from './track-by-no.component';

const routes: Routes = [
    {
        path: '',
        component: TrackByNoComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TrackByNoPageRoutingModule { }
